export const IKKE_SVAR_TEKST = 'Jeg ønsker ikke å svare'
export const OVERSKRIFT_TEKST = 'Hva er grunnen til at du er her?'
export const INFO_TEKST =
    'Vi jobber med å forbedre denne tjenesten, og trenger derfor å vite litt mer om brukerne våre og hvorfor dere besøker trafikkulykkesregisteret.'
